/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * SelectionMultipleIcon
 */
export default class SelectionMultipleIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M5 16a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2v-2a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 20H10a1 1 0 01-.117-1.993L10 18h12zM5 18H3v2h2v-2zm0-9a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2v-2a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 13H10a1 1 0 01-.117-1.993L10 11h12zM5 11H3v2h2v-2zm0-9a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2V4a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 6H10a1 1 0 01-.117-1.993L10 4h12zM5 4H3v2h2V4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

